module.exports = __webpack_public_path__ + "img/discount.de91b564.png";